// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader/dist/cjs.js?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=data-v-58d7f15b&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Users/UserProfile/UserProfile.vue
// module id = 446
// module chunks = 0